export class equityMarginDetailModel {
// setValue(res){
// if(res){
// }
// }
}